import { theme } from '@app/theme';

type OutlinedInputClasses = Record<'input' | 'notchedOutline' | 'focused' | 'disabled', string>;

export const getOutlinedInputClasses = (
  colors: { main: string; light: string; dark: string; shadow: string },
  outlinedInputClasses: OutlinedInputClasses,
  variant: 'default' | 'attention',
) => ({
  backgroundColor: variant === 'default' ? theme.palette.common.white : colors.light,
  [`&.${outlinedInputClasses.focused}`]: {
    backgroundColor: theme.palette.common.white,
  },
  [`& .${outlinedInputClasses.input}::placeholder`]: {
    opacity: 1,
  },
  [`& .${outlinedInputClasses.notchedOutline}`]: {
    borderColor: variant === 'default' ? theme.palette.grey[200] : colors.main,
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    boxShadow: 'none',
  },
  [`&:hover:not(.${outlinedInputClasses.focused}):not(.${outlinedInputClasses.disabled}) .${outlinedInputClasses.notchedOutline}`]:
    {
      borderColor: variant === 'default' ? theme.palette.grey[400] : colors.main,
    },
  [`&.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
    borderColor: colors.dark,
    borderWidth: 1,
    boxShadow: `0 0 3px 3px ${colors.shadow}`,
  },
});
